import _ from "lodash";
import React from "react";

import { Modal } from "@toddle-edu/ds-web";
import useI18n from "Hooks/UseI18n";

import FormTemplates from "./FormTemplates";
import FormTemplateFilterHeader from "./FormTemplateFilterHeader";
import classes from "./FormTemplateModal.scss";
import { connect } from "react-redux";
import {
  getMessagingV2ReduxState,
  setFormTemplateModal,
} from "MessagingV2/modules/MessagingModule";
import { useDispatch } from "Hooks/useDispatch";

const styles = {
  modalBodyStyle: {
    padding: "0px",
    overflow: "hidden",
  },
};

const FormTemplateModal = props => {
  const { chatId, formTemplateModal } = props;
  const dispatch = useDispatch();
  const [searchText, setSearchText] = React.useState("");
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const containerRef = React.useRef(null);
  const { t } = useI18n(["common"]);

  const onCloseModal = React.useCallback(
    () => dispatch(setFormTemplateModal(false)),
    [dispatch]
  );

  return formTemplateModal ? (
    <Modal
      dsVersion="2.0"
      height="700px"
      width="1312px"
      hasOverlay
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onCloseModal}
      isOpen
    >
      <Modal.Header title={t("common:template_library")} isClosable />

      <Modal.Body style={styles.modalBodyStyle}>
        <div className={classes.modalBodyContainer}>
          <div className={classes.formTemplateFilterContainer}>
            <FormTemplateFilterHeader
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              setSearchText={setSearchText}
              searchText={searchText}
            />
          </div>
          <div className={classes.formTemplatesContainer} ref={containerRef}>
            <FormTemplates
              searchText={searchText}
              selectedUsers={selectedUsers}
              containerRef={containerRef}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  ) : null;
};

const mapStateToProps = state => {
  const messagingState = getMessagingV2ReduxState(state);
  const formTemplateModal = _.get(messagingState, "formTemplateModal", false);
  return {
    formTemplateModal,
  };
};

export default connect(mapStateToProps)(FormTemplateModal);
